import FeatureDashboard from "../../../components/base/FeatureDashboard";
import ActividadLive from "./ActividadLive";
import PipelineSection from "./PipelineSection";
import ForecastView from "./ForecastView";
import EconomicsDashboard from "./economics/EconomicsDashboard";

// ===========================================================================
// Panel CRM — la portada del CRM es la economía del embudo (#1291): costos de
// marketing y del equipo comercial cruzados con leads y negocios de HubSpot
// (costo por lead, costo por etapa, costo esperado de cierre, cohortes,
// documentos). Datos reales del API; ver sections/economics/.
// ===========================================================================

export const PanelDashboard = () => <EconomicsDashboard />;

// --- Actividad (log de toda la cuenta) -------------------------------------
// LIVE: real account timeline fed by the CRM activity triggers (leads created,
// lead status changes, calls placed and their outcome). See ActividadLive.
export const ActividadSection = () => <ActividadLive />;

// --- Pipeline + Pronóstico -------------------------------------------------
// Brought into the Panel CRM as first-class screens. Both are fully interactive
// and share the deals store with the Negocios section (see PipelineBoard /
// ForecastView): a move on the board re-weights the forecast everywhere.
// The very same screen as Negocios → Pipeline (one component, two routes).
export const PanelPipelineSection = PipelineSection;
export const PanelPronosticoSection = () => <ForecastView />;

// --- Embudo de ventas ------------------------------------------------------
export function EmbudoDashboard() {
  return (
    <FeatureDashboard noticeKey="crm.mockNotice"
      title="Embudo de ventas"
      subtitle="Conversión por etapa del pipeline"
      icon="ri-filter-3-line"
      stats={[
        { label: "Oportunidades", value: "42", icon: "ri-add-circle-line" },
        { label: "Calificados", value: "28", icon: "ri-checkbox-circle-line" },
        { label: "Propuestas", value: "15", icon: "ri-file-text-line" },
        { label: "Ganados", value: "9", icon: "ri-trophy-line" },
      ]}
      chart={{
        title: "Negocios por etapa",
        data: [
          { name: "Nuevo", value: 42 }, { name: "Contactado", value: 35 }, { name: "Calificado", value: 28 },
          { name: "Propuesta", value: 15 }, { name: "Negociación", value: 11 }, { name: "Ganado", value: 9 },
        ],
      }}
    />
  );
}
